import { createFileRoute, notFound } from '@tanstack/react-router';
import { lazyScreen } from '@/shared/screen';

// Catálogo só existe em dev (plano E2.4): em produção a rota responde 404 e o chunk nem é pedido.
export const Route = createFileRoute('/dev/ui')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound() é o contrato do TanStack Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-ui-catalog'), 'UiCatalog') : () => null,
});
